import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import CloseIconBlackBg from 'web/assets/svg/CloseIconBlackBg'

import Card from 'web/pages/private/CommonPages/MyNetworks/SearchResult/Card'
import { BoxContainer, BoxContainerHeader, ActionBtn } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";
import { CardWrapper } from "web/pages/private/CommonPages/MyNetworks/SearchResult/SearchResultStyled";

const SearchResult = ({ isMemberOrGroup, searchState, closeIconCallBack, inviteCallBack, pageLanguageContents, ...props }) => {
  const { searchTotalElementsState, searchPagePostionInfo, searchGroupApiFunCallBack } = props
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [page, setPage] = useState(1);
  const cardWrapperRef = useRef(null);

  useEffect(() => {
    if (searchPagePostionInfo === 'pageResetToOne' && cardWrapperRef.current) {
      cardWrapperRef.current.scrollTop = 0;
    }
  }, [searchPagePostionInfo]);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (searchPagePostionInfo === 'endOfResults') {
      if (page !== 1) setPage(prevPage => prevPage - 1);
    } else if (scrollHeight - scrollTop <= clientHeight * 1.2 && !loaderVisible) {
      if (searchPagePostionInfo === 'pageResetToOne') {
        setPage(2);
        searchGroupApiFunCallBack(2);
      } else {
        setPage(prevPage => prevPage + 1);
        searchGroupApiFunCallBack(page + 1);
      }
    }
  };

  return (
    <BoxContainer>
      {searchState ?
        <>
          <BoxContainerHeader>
            <h2>'{searchTotalElementsState ?? 0}' {pageLanguageContents?.SearchResults[0]?.ResultsFound}</h2>
            <CloseIconBlackBg onClick={closeIconCallBack} />
          </BoxContainerHeader>
          <CardWrapper>
            <div ref={cardWrapperRef} className='card-box-wrapper' onScroll={handleScroll}>
              {searchState.map((item) =>
                <Card
                  item={item}
                  isMemberOrGroup={isMemberOrGroup}
                  pageLanguageContents={pageLanguageContents}
                  cardCallBack={(type, selectedItem) => closeIconCallBack(type, selectedItem)}
                  inviteCallBack={inviteCallBack} />
              )}
            </div>
          </CardWrapper>
        </>
        :
        <BoxContainerHeader>
          <h2>No records found</h2>
        </BoxContainerHeader>
      }
    </BoxContainer>
  );
}

export default SearchResult;
